<template>
<div class="account-detail container">
  <div class="account-settings-wrapper">
    <div v-if="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-grow m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else>
      <h4>Контактные данные </h4>
      <div class="row py-3">
        <div class="col-4">
          <h6>Абонент</h6>
        </div>
        <div class="col-8 text-center">
          <strong>
            {{ userData.last_name }} {{ userData.first_name }} {{ userData.middle_name }}
          </strong>
        </div>
      </div>
      <div class="row py-3">
        <div class="col-5">
          <h6>Email</h6>
        </div>
        <div class="col-7 text-center">
          <input type="email" v-on:change="updateUserData({ email: userData.email })"
                 v-model="userData.email" class="custom-input">
        </div>
      </div>
    </div>

    <div class="pt-3">
      <h4>Изменить пароль</h4>
      <div class="row py-3">
        <div v-if="changeError" class="error col-12 py-3">
          <div v-for="(e, k) in changeErrorText" :key="k">
             <font-awesome-icon :icon="['fa', 'exclamation']" />
             <small class="pl-3">{{ e[0] }}</small>
           </div>
        </div>
        <div class="col">
          <h6>Текущий пароль</h6>
        </div>
        <div class="col text-center">
          <input v-model="passwordInputs.password"  class="custom-input"  type="password">
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-6">
          <h6>Новый пароль</h6>
          <transition name="hint" appear>
            <div v-if='passwordValidation.errors.length > 0 && !submitted' class='hints'>
              <small v-for='error in passwordValidation.errors' v-bind:key="error">
                - {{error}}<br>
              </small>
            </div>
          </transition>
        </div>
        <div class="col-5 text-center">
          <input :class='{valid:passwordValidation.valid}' class="custom-input"
                 :type="passwordVisible ? 'text' : 'password'" v-model="passwordInputs.password1">
        </div>
        <div class="col-1">
          <font-awesome-icon
                  @click="togglePasswordVisibility()"
                  :arial-label='passwordVisible ? "Hide password" : "Show password"'
                  :icon="passwordVisible ? ['fas', 'eye-slash'] : ['fas', 'eye']" />
        </div>
      </div>
      <div class="row pb-3">
        <div class="col">
          <h6>Новый пароль еще раз</h6>
          <small v-if='notSamePasswords'>- Passwords match.</small>
        </div>
        <div class="col text-center">
          <input class="custom-input"  type="password" v-model='passwordInputs.password2'>
        </div>
      </div>
      <div class="row py-3">
        <div class="col"></div>
        <div class="col text-center">
            <button
              @click='changePassword'
              class="btn-primary"
              v-if='passwordsFilled && !notSamePasswords && passwordValidation.valid'>
              Изменить пароль
            </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'account-detail',
  props: {
    loading: {
      default: false,
    },
  },
  data() {
    return {
      passwordInputs: {
        password: '',
        password1: '',
        password2: '',
      },
      rules: [
        { message: 'Требуется одна строчная буква.', regex: /[a-z]+/ },
        { message: 'Требуется одна заглавная буква.', regex: /[A-Z]+/ },
        { message: 'Минимум 8 символов.', regex: /.{8,}/ },
        { message: 'Требуется одина цифра.', regex: /[0-9]+/ },
      ],
      passwordVisible: false,
      submitted: false,
    };
  },
  methods: {
    getUserDetail() {
      this.$store.dispatch('user/getUserDetail')
        .finally(() => {
          this.loading = false;
        });
    },
    updateUserData(input) {
      const newData = { userId: this.userData.id, data: input };
      this.$store.dispatch('user/updateUserData', newData)
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'success',
              text: 'Информация успешно обновлена!',
            });
          } else {
            this.$notify({
              group: 'message',
              title: 'New message:',
              type: 'error',
              text: 'Произошла ошибка!',
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    changePassword() {
      this.$store.dispatch('password/changePassword', this.passwordInputs)
        .then(() => {
          if (!this.changeError) {
            this.$store.dispatch('auth/logout')
              .then(() => this.$router.push({ name: 'login' }));
          }
        });
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
  computed: {
    ...mapState('password', ['changeError', 'changeErrorText']),
    ...mapState('user', ['userData', 'error']),
    notSamePasswords() {
      if (this.passwordsFilled) {
        return (this.passwordInputs.password1 !== this.passwordInputs.password2);
      }
      return false;
    },
    passwordsFilled() {
      return (this.passwordInputs.password1 !== '' && this.passwordInputs.password2 !== '');
    },
    passwordValidation() {
      const errors = [];
      this.rules.forEach((element) => {
        if (!element.regex.test(this.passwordInputs.password1)) {
          errors.push(element.message);
        }
      });
      if (errors.length === 0) {
        return { valid: true, errors };
      }
      return { valid: false, errors };
    },
  },
  created() {
    return this.getUserDetail();
  },
};
</script>
